import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {WB_GeneralLedgerAccountRow} from "../PA.Core/PAdbSchemaRows";
import {IwbGeneralLedgerAccount} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_General_Ledger_Account
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver"
import {ASync} from "../PA.Core/Basic/ASync"
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export interface IGeneralLedgerAccountLoadOptions {
    dbContext?: PAdbContext
}

const GeneralLedgerAccountLoadOptions_default: IGeneralLedgerAccountLoadOptions = {}

export class GeneralLedgerAccountBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_GeneralLedgerAccount: WB_GeneralLedgerAccountRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New General Ledger'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_GeneralLedgerAccount = undefined;
    }

    get WB_GeneralLedgerAccount(): WB_GeneralLedgerAccountRow
    {
        return this.drWB_GeneralLedgerAccount;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating GeneralLedgerAccount");
        let internalOnComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new GeneralLedgerAccount.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_General_Ledger_Account)
                .then((newGeneralLedgerAccountRow: WB_GeneralLedgerAccountRow)=> {
                    newGeneralLedgerAccountRow.setDefaults()
                    self.drWB_GeneralLedgerAccount = newGeneralLedgerAccountRow;
                    self.dbContext.add(esWB_General_Ledger_Account, newGeneralLedgerAccountRow)
                    self.Identity.setAll(self.WB_GeneralLedgerAccount.cif.WB_GLACCT_ID, self.WB_GeneralLedgerAccount.cif.WB_GLACCT_ID, self.WB_GeneralLedgerAccount.cif.GLACCOUNT_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_GeneralLedgerAccount, 'WB_GLACCT_ID','WB_GLACCT_ID','GLACCOUNT_NAME')


                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);

                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        self._OnLoadComplete = internalOnComplete

        return  new Promise<IBusinessObject>( (resolve, error) => {
            internalOnComplete
                .then((BO) => {
                    return ASync.resolve()
                }).then((ignored) => {
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.finish()
                resolve(self)
            }).catch((err) => {
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(err)
                error(err)
            })
        })
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        var self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");


        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("General Ledger already loaded.")
                resolve(self); // "Customer already loaded.";
                return;
            }

            self.LoadOptions = options || {};
            _.defaults(self.LoadOptions, GeneralLedgerAccountLoadOptions_default)


            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isUndefined(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isUndefined(self.dbContext)) {
                error("Unable to determine dbContext for General Ledger.")
                return;
            }

            if('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any> self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = GeneralLedgerAccountBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = GeneralLedgerAccountBO.setupRecordResolver(recordResolver, [anId])
            }


            recordResolverLoadPromise
                .then(function () {
                    let aGeneralLedgerAccountRow: any = recordResolver.get(esWB_General_Ledger_Account, anId)

                    if (_.isEmpty(aGeneralLedgerAccountRow)) {
                        error("General Ledger not Found");
                        return;
                    }

                    self.drWB_GeneralLedgerAccount = aGeneralLedgerAccountRow;
                    self.Identity.setAll(self.WB_GeneralLedgerAccount.cif.WB_GLACCT_ID, self.WB_GeneralLedgerAccount.cif.WB_GLACCT_ID, self.WB_GeneralLedgerAccount.cif.GLACCOUNT_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_GeneralLedgerAccount, 'WB_GLACCT_ID','WB_GLACCT_ID','GLACCOUNT_NAME')
                    self._bIsLoaded = true
                    self._OnLoadComplete = undefined
                    self.LoadProgressProvider.finish()
                    resolve(self)
                }).catch(function (err: any) {
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(err)
                error(err)
                return;
            });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_GeneralLedgerAccount.cif.GLACCOUNT_NAME + "(" + self.WB_GeneralLedgerAccount.cif.WB_GLACCT_ID + ")");
        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if(self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate GeneralLedgerAccount.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbGeneralLedgerAccount = <IwbGeneralLedgerAccount>self.drWB_GeneralLedgerAccount;
        this.SaveProgressProvider.start("Saving " + wbGeneralLedgerAccount.GLACCOUNT_NAME + "(" + wbGeneralLedgerAccount.WB_GLACCT_ID + ")");

        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if(this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save GeneralLedgerAccount.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            self.SaveOptions = options || {};

            var saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            saveFunction(esWB_General_Ledger_Account, self.drWB_GeneralLedgerAccount,{})
                /*.then((ignore) => {
                    var tasks: Promise<any>[] = []

                    tasks.push(saveFunction(esWB_Customer_Relationship,
                        self.drWB_Customer.WB_CustomerRelationshipRows_Children))
                    return Promise.all(tasks)
                })*/
                .then((ignored) => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(()=> {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })
        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbGeneralLedgerAccount = <IwbGeneralLedgerAccount>self.drWB_GeneralLedgerAccount;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbGeneralLedgerAccount.GLACCOUNT_NAME + "(" + wbGeneralLedgerAccount.WB_GLACCT_ID + ")");
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the GeneralLedgerAccount

            // 2. If Valid, mark all the records for deletion.
            self.drWB_GeneralLedgerAccount.markDeleted()

            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }
    //</editor-fold>

    //<editor-fold desc = "Record Resolver operations">
    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const wrksp_options: CreateOptions = {
            standardConditions: {
            },
            dctIncludeBelongsToNamedRelations: {
            }
        }

        const aRecResolver = new ESRecordResolver(dbContext, wrksp_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_General_Ledger_Account,ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

//</editor-fold">

};
PAEnvironment.registerBusinessObjectClass( GeneralLedgerAccountBO , "GeneralLedgerAccountBO", "General Ledger Account")